export default __webpack_public_path__ + "3b460f543aeb8c92df174eff2d456fd7.png";